import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
import {report_product_receipt} from "../../../components/Report.js";
export default class ReceiveGoods extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_detail: false,

      filter_search: "",
      filter_ref_number: "",
      filter_receive_date: "",
      filter_warehouse_id: "",
      filter_company_id: "",
      filter_status: "",

      data: [],
      count: 10,
      data_product: [],
      data_user: [],
      data_warehouse: [],
      data_category: [],
      data_company: [],

      data_check: [],

      tab: "check-list",

      id: "",
      uid: "",
      return_code: "",

      // สินค้า
      type: "",
      name: "",
      date: "",
      start_date: "",
      end_date: "",
      count_item: "",
      ref_number: "",
      activity_type: "",
      customer_id: "",
      supplier_id: "",
      warehouse_id: "",
      user_id: "",
      amount: "",
      discount: "",
      vat: "",
      amount_net: "",
      cause: "",
      status: "",
      remark: "",
      transaction_list: [],

      category_id: "",

      detail: null,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
  }

  Get = async (page) => {
    const {
      filter_search,
      filter_ref_number,
      filter_receive_date,
      filter_warehouse_id,
      filter_company_id,
      filter_status,
    } = this.state;
    const refNumberTrim = (filter_ref_number || "").trim();
    const stockListParams = {
      page: page,
      data_search: filter_search,
      date: filter_receive_date,
      warehouse_id: filter_warehouse_id,
      supplier_id: filter_company_id,
      status_code: filter_status,
      type: "รับสินค้า",
    };
    if (refNumberTrim) {
      stockListParams.ref_number = refNumberTrim;
    }
    let data, count, data_user, data_warehouse, data_category, data_company;
    loading(true);
    let [
      result,
      result_user,
      result_warehouse,
      result_category,
      result_company,
    ] = await Promise.all([
      GET("admin/stock-activities/list", stockListParams),
      GET("admin/setting/users/list", { page: 0, data_search: "" }),
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
      GET("admin/setting/companies/list", { page: 0, data_search: "" }),
    ]);
    if (result?.status) {
      data = result.data;
      count = result.count;
    }
    if (result_user?.status) {
      data_user = result_user.data.map((e) => ({
        value: e.uid,
        label: e.full_name,
      }));
    }
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_category?.status) {
      
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
    }
    if (result_company?.status) {
      data_company = result_company.data.map((e) => ({
        value: e.uid,
        label: e.company_name,
        warehouse_id: e.warehouse?.uid,
      }));
    }
    this.setState({
      data,
      count,
      data_user,
      data_warehouse,
      data_category,
      data_company,
    });
    loading(false);
  };
  GetByID = async (uid) => {
    loading(true);
    let result = await GET("admin/stock-activities/list", { uid });
    this.setState({ detail: result.data, modal_detail: true });
    loading(false);
  };
  GetSup = async (id, document_no) => {
    loading(true);
    let result = await GET("admin/stock-activities/list", {
      ref_number: document_no,
      status_code: "เสร็จสิ้น",
      type: "คืนสินค้าให้ Sup",
    });

    loading(false);
    if (result.data.length === 0) {
      this.Delete(id);
    } else {
      alert(
        "",
        "warning",
        "แจ้งเตือน",
        "ไม่สามารถยกเลิกรายการนี้ได้ เนื่องจากมีการใช้งานเอกสารฉบับนี้อยู่ โปรดยกเลิกรายการเอกสารที่ใช้งานนั้นๆก่อนทำการยกเลิก"
      );
      return;
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        "ยกเลิก",
        "ยืนยันรายการนี้หรือไม่ ?",
        "ยืนยัน",
        "ยกเลิก"
      )
    ) {
      loading(true);

      let body = {
        status: "ยกเลิก",
      };

      let result = await PUT("admin/stock-activities/update/" + id, body);
      if (result?.status) {
        alert("#", "success");
      } else {
        alert(
          "",
          "warning",
          "แจ้งเตือน",
          result?.message || "เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง"
        );
      }
      loading(false);
    }
  };
  render() {
    const {
      modal_detail,
      filter_search,
      filter_ref_number,
      filter_receive_date,
      filter_warehouse_id,
      filter_company_id,
      filter_status,
      data,
      count,
      data_warehouse,
      data_company,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
      detail,
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">รายการรับสินค้า</h4>
              <button
                className="btn btn-dark px-3 ms-auto mb-2 receive-goods.create"
                onClick={async () => {
                  window.location.href = "/stock/receive-goods/create";
                }}
              >
                เพิ่มรายการ
              </button>
            </div>
            <div className="d-flex flex-wrap">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา เลขที่เอกสาร, บริษัท..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="text"
                className="form-control wpx-220 me-2 mb-2"
                placeholder="เลขที่อ้างอิง PO"
                onChange={(e) => {
                  this.setState({ filter_ref_number: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_ref_number}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_receive_date: e.target.value });
                }}
                value={filter_receive_date}
              />
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e, filter_company_id: "" });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder={
                    filter_warehouse_id
                      ? "บริษัทจำหน่าย..."
                      : "เลือกคลังสินค้าก่อน..."
                  }
                  disabled={!filter_warehouse_id}
                  options={data_company.filter(
                    (e) =>
                      filter_warehouse_id &&
                      e.warehouse_id === filter_warehouse_id
                  )}
                  onChange={(e) => {
                    this.setState({ filter_company_id: e });
                  }}
                  value={filter_company_id}
                />
              </div>
              <select
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_status: e.target.value });
                }}
                value={filter_status}
              >
                <option value="">เลือกสถานะ</option>
                <option value="เสร็จสิ้น">เสร็จสิ้น</option>
                <option value="ยกเลิก">ยกเลิก</option>
              </select>

              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.Get(1);
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({
                      filter_search: "",
                      filter_ref_number: "",
                      filter_receive_date: "",
                      filter_warehouse_id: "",
                      filter_company_id: "",
                      filter_category_id: "",
                      filter_status: "",
                      filter_start_date: "",
                      filter_end_date: "",
                    });
                    setTimeout(() => {
                      this.Get(1);
                    }, 100);
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">วันที่รับเข้า</td>
                    <td className="text-nowrap">เลขที่เอกสาร</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">บริษัทจำหน่าย</td>
                    <td className="text-nowrap">สถานะ</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">
                        {item.date ? format_date(item.date) : "-"}
                      </td>
                      <td className="text-nowrap">{item.document_no || "-"}</td>
                      <td className="text-nowrap">
                        {item.warehouse?.name || "-"}
                      </td>
                      <td className="text-nowrap">
                        {item.supplier?.company_name || "-"}
                      </td>
                      <td className="text-nowrap">{item.status || "-"}</td>
                      <td className="text-center align-middle wpx-100">
                        <div className="d-flex">
                          <BtnIcon
                            type="view"
                            onClick={() => {
                              this.GetByID(item.uid);
                            }}
                          />
                          {item.status === "เสร็จสิ้น" && (
                            <BtnIcon
                              className="receive-goods.delete"
                              type="delete"
                              onClick={() => {
                                this.GetSup(item.uid, item.document_no);
                                // this.Delete(item.uid);
                              }}
                            />
                          )}
                          <BtnIcon type="print" onClick={() => {
                            report_product_receipt(item.uid)
                          }} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="w-100 d-flex align-items-center justify-content-end flex-wrap mt-2">
            <Pagination
              className="mb-3"
              count={Math.ceil(count / 10) || 1}
              showFirstButton
              showLastButton
              onChange={(_, page) => this.Get(page)}
            />
          </div>
        </div>
        {/* VIEW */}
        <Modal
          show={this.state.modal_detail}
          onHide={() => this.setState({ modal_detail: false })}
          size="lg"
        >
          <Modal.Header closeButton>
            <h4 className="mb-0">รายละเอียด</h4>
          </Modal.Header>
          <Modal.Body className="pb-0">
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">สถานะ</label>
              <label>
                {detail?.status === "เสร็จสิ้น"
                  ? Status("เสร็จสิ้น", "success")
                  : Status("ยกเลิก", "danger")}
              </label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">เลขที่เอกสาร</label>
              <label>{detail?.document_no || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">วันที่รับสินค้า</label>
              <label>{detail?.date ? format_date(detail?.date) : ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">คลังสินค้า</label>
              <label>{detail?.warehouse?.name || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">ประเภทการรับ</label>
              <label>{detail?.activity_type || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">บริษัทจำหน่าย</label>
              <label>{detail?.supplier?.company_name || ""}</label>
            </div>
            <div className="d-flex mb-2 flex-wrap">
              <label className="wpx-150">เลขที่อ้างอิง PO</label>
              <label>{detail?.ref_number || ""}</label>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">ลำดับ</td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial No.</td>
                    <td className="text-nowrap text-center">จำนวน</td>
                    <td className="text-nowrap text-center">ราคา/หน่วย</td>
                    <td className="text-nowrap text-center">ส่วนลด</td>
                    <td className="text-nowrap text-end">ราคาหลังหักส่วนลด</td>
                    <td className="text-nowrap text-end">มูลค่ารวม</td>
                  </tr>
                </thead>
                <tbody>
                  {detail?.transaction_list?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{index + 1}</td>
                      <td className="text-nowrap">
                        {item.product_code} {item.product_name}
                      </td>
                      <td className="text-nowrap">
                        {item.serial_number?.join(", ") || ""}
                      </td>
                      <td className="text-nowrap">{item.qty}</td>
                      <td className="text-nowrap">{item.unit_price}</td>
                      <td className="text-nowrap">{item.discount}</td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.unit_price) - Number(item.discount)
                        )}
                      </td>
                      <td className="text-nowrap text-end">
                        {toFixed(
                          Number(item.qty) *
                            (Number(item.unit_price) - Number(item.discount))
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="row">
              <div className="col-12 col-lg-5">
                <div className="d-flex mb-2 flex-wrap">
                  <label className="wpx-150">หมายเหตุ</label>
                  <label>{detail?.remark || ""}</label>
                </div>
              </div>
              <div className="col-12 col-lg-7">
                <div className="d-flex justify-content-between mb-2 flex-wrap">
                  <label>รวมเป็นเงิน</label>
                  <label className="text-end ps-2">
                    {toFixed(detail?.amount)} บาท
                  </label>
                </div>
                <div className="d-flex justify-content-between mb-2 flex-wrap">
                  <label>ส่วนลด</label>
                  <label className="text-end ps-2">
                    {toFixed(detail?.discount)} บาท
                  </label>
                </div>
                <div className="d-flex justify-content-between mb-2 flex-wrap">
                  <label>ราคาหลังหักส่วนลด</label>
                  <label className="text-end ps-2">
                    {toFixed(detail?.amount - detail?.discount)} บาท
                  </label>
                </div>
                <div className="d-flex justify-content-between mb-2 flex-wrap">
                  <label>ภาษีมูลค่าเพิ่ม 7%</label>
                  <label className="text-end ps-2">
                    {toFixed(detail?.vat)} บาท
                  </label>
                </div>
                <div className="d-flex justify-content-between mb-2 flex-wrap">
                  <label>ค่าส่ง</label>
                  <label className="text-end ps-2">
                    {toFixed(detail?.delivery_cost)} บาท
                  </label>
                </div>
                <div className="d-flex justify-content-between mb-2 flex-wrap">
                  <label>จำนวนเงินรวมทั้งหมด</label>
                  <label className="text-end ps-2">
                    {toFixed(detail?.amount_net)} บาท
                  </label>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
